import { render, staticRenderFns } from "./WhatsappCard.vue?vue&type=template&id=5865b8fe&scoped=true&"
import script from "./WhatsappCard.vue?vue&type=script&lang=js&"
export * from "./WhatsappCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865b8fe",
  null
  
)

export default component.exports